import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { OperacaoFinanceiraInserirRoutingModule } from "./operacao-financeira-inserir-routing.module";
import { OperacaoFinanceiraInserirComponent } from "./operacao-financeira-inserir.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';




@NgModule({
    imports: [
        CommonModule,            
        OperacaoFinanceiraInserirRoutingModule,
        HttpClientModule,        
        FormsModule,
        ButtonModule,
        InputTextModule,
        DividerModule,
        DropdownModule,
        MessagesModule,
        InputSwitchModule,
        InputSwitchModule
    ],
    declarations: [OperacaoFinanceiraInserirComponent]
})
export class OperacaoFinanceiraInserirModule { }
